import SongDetails from './SongDetails';
import PlayControls from './PlayControls';
import ExtraControlButtons from './ExtraButtons';
import NowPlayingBarMobile from './mobilePlayer';
import { MobileMenu } from './mobileMenu';
import { OtherDeviceAlert } from './otherDevice';
import YoutubeMiniPlayer from '../../../Youtube/YoutubeMiniPlayer';

const NowPlayingBar = () => {
  return (
    <>
      <div>
        <YoutubeMiniPlayer />
        <div className='w-full bg-black p-4 h-full mobile-hidden now-playing-layout'>
          <div className='justify-self-start'>
            <SongDetails />
          </div>
          <div className='justify-self-center w-full'>
            <PlayControls />
          </div>
          <div className='justify-self-end flex justify-end w-full'>
            <ExtraControlButtons />
          </div>
        </div>

        <OtherDeviceAlert />
      </div>

      <div className='mobile-bar'>
        <NowPlayingBarMobile />
        <MobileMenu />
      </div>
    </>
  );
};

export default NowPlayingBar;
